/**
 * Formats categories and subcategories hierarchically for display in dropdown selections.
 * Subcategories are formatted as "Parent Category > Subcategory" and sorted accordingly.
 * 
 * @param {Array} categories - Array of categories from the backend
 * @returns {Array} Formatted categories array
 */
export const formatCategoriesForDropdown = (categories) => {
    if (!Array.isArray(categories)) return [];

    // Separate parents and subcategories
    const parents = categories.filter(c => !c.parent_id);
    const subcategories = categories.filter(c => c.parent_id);

    const result = [];
    parents.forEach(parent => {
        // Add parent category
        result.push({ ...parent, displayName: parent.name });
        
        // Find subcategories belonging to this parent and add them
        const children = subcategories.filter(sub => String(sub.parent_id) === String(parent.id));
        children.forEach(child => {
            result.push({ ...child, displayName: `${parent.name} > ${child.name}` });
        });
    });

    // Capture any orphan subcategories whose parent is not in the list
    subcategories.forEach(sub => {
        if (!result.some(r => r.id === sub.id)) {
            result.push({ ...sub, displayName: sub.name });
        }
    });

    return result;
};
